import { render, staticRenderFns } from "./TestimonialSection.vue?vue&type=template&id=2f1c8418&scoped=true&"
import script from "./TestimonialSection.vue?vue&type=script&lang=js&"
export * from "./TestimonialSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1c8418",
  null
  
)

export default component.exports